export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otevřít spor"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušit"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["K pomoci se připojí moderátor. Vyberte prosím důvod a připojte důkazy."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat moderátorovi"])}
}